export default "__VITE_ASSET__IFg8CI27__"